import {
    itemNameLocale,
    makeToast,
    MSG_BIP, MSG_CARD_SEC,
    MSG_CDF,
    MSG_FIELD,
    MSG_FILTER,
    MSG_SMS,
    trMsg
} from "./bip-types";

export default {

    computed: {
    },
    data() {
        return {
            MSG_BIP: MSG_BIP,
            MSG_FILTER: MSG_FILTER,
            MSG_SMS: MSG_SMS,
            MSG_CDF: MSG_CDF,
            MSG_FIELD: MSG_FIELD,
            MSG_CARD_SEC: MSG_CARD_SEC,
            categories: []
        }
    },

    methods: {
        getLocText(field, extra = null) {
            const link = 'modules.budget_request.files_updown.';
            return this.getText(link, field, extra)
        },

        getText(link, field, extra = null) {
            const mainTextFieldName = link + field;
            if (extra) {
                if (typeof extra === 'number') return this.$tc(mainTextFieldName, extra)
                else return this.$t(mainTextFieldName, extra);
            };
            return this.$t(mainTextFieldName);
        },

        async loadDict() {
            try {
                const catFiles = [];

                const response = await fetch('/api-py/dictionary/bip_files_type/');
                if (response.status === 200) {
                    const items = await response.json();

                    for (const row of items) {
                        const el = {...row};
                        this.$set(el, 'files', []);
                        catFiles.push(el);
                        itemNameLocale(el)
                    }
                    this.$set(this, 'categories', catFiles);
                }
            } catch (error) {
                makeToast(this, 'danger', `${this.getErrText('bad_request')} loadTModels()`,
                    error.toString());
            }
        },

        // translate methods
        trMsg(field) {
            return trMsg(this, field);
        }
    }
}